import React from "react";
import { Box } from "@chakra-ui/react";

const AboutGL = ({ content }) => {
  return <Box>{content}</Box>;
};

export default AboutGL;
